import {useMemo} from 'react';
import type {DataFormConfigurationContextType} from 'schema';

export const useCollectionFormConfiguration = () => {
  return useMemo((): DataFormConfigurationContextType => {
    const config: DataFormConfigurationContextType = {
      schemaContainers: {
        titles: 'NoContainer',
      },
      parts: {
        value: {
          layout: {
            flex: 1,
          },
        },
        language: {
          layout: {
            flex: 1,
          },
        },
      },
    };
    return config;
  }, []);
};
